import type { ProjectReportsGatewayPort } from "@/application/project-reports/ports/ProjectReportsGatewayPort";

export class DeleteProjectReportUseCase {
  constructor(private readonly gateway: ProjectReportsGatewayPort) {}

  async execute(projectId: string, reportId: string): Promise<void> {
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }
    if (!reportId || reportId.trim().length === 0) {
      throw new Error("Report ID is required");
    }

    await this.gateway.delete(projectId, reportId);
  }
}
